import React from "react";
import Template from "./template";
import homePageJson from "../../content/pages/home/index.json";

function UserStories() {
  const { userStories } = homePageJson;
  return <Template data={userStories} />;
}

export default UserStories;
